import { createReducer } from "@reduxjs/toolkit";
import moment from "moment";
import { postRicercaProcessi, resetForm, setDataFineAction, setDataInizioAction, setModalitaCertificazioneAction, setNdgCertificazioneAction, setNominativoCertificazioneAction, setPaginaSelezionataAction, setProcessoAction, setStatoCertificazioneAction, setTipoCerficazioneAction } from "./actions";
import { RicercaClientiReducerType } from "./types";

const initialState: RicercaClientiReducerType = {
  form: {
    ndg: '',
    nominativo: '',
    dataInizio: moment().subtract('7', 'days').toDate(),
    dataFine: moment().toDate(),
    modalitaCertificazione: 0,
    processo: 0,
    statoCertificazione: 0,
    paginaSelezionata: 1,
    tipoCertificazione: 0
  },
  risultato: undefined,
};

export const ricercaClientiReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(postRicercaProcessi.pending, (state) => {
      state.risultato = initialState.risultato;
    })
    .addCase(postRicercaProcessi.fulfilled, (state, action) => {
      state.risultato = action.payload;
    })
    .addCase(setNdgCertificazioneAction, (state, action) => {
      state.form.ndg = action.payload;
    })

    .addCase(setNominativoCertificazioneAction, (state, action) => {
      state.form.nominativo = action.payload;
    })

    .addCase(setDataInizioAction, (state, action) => {
      state.form.dataInizio = action.payload;
    })

    .addCase(setDataFineAction, (state, action) => {
      state.form.dataFine = action.payload;
    })

    .addCase(setModalitaCertificazioneAction, (state, action) => {
      state.form.modalitaCertificazione = action.payload;
    })

    .addCase(setProcessoAction, (state, action) => {
      state.form.processo = action.payload;
    })

    .addCase(setTipoCerficazioneAction, (state, action) => {
      state.form.tipoCertificazione = action.payload;
    })

    .addCase(setStatoCertificazioneAction, (state, action) => {
      state.form.statoCertificazione = action.payload;
    })

    .addCase(setPaginaSelezionataAction, (state, action) => {
      state.form.paginaSelezionata = action.payload;
    })

    .addCase(resetForm, (state) => {
      state.form = initialState.form;
    });

});
